import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function useCaptcha() {
  const [captcha, setCaptcha] = useState(null);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/captcha");
      setCaptcha({ id: data.id, question: data.question, answer: "" });
    } catch {
      setCaptcha({ id: "", question: "CAPTCHA indisponible, réessayez", answer: "" });
    }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const fields = captcha ? { captcha_id: captcha.id, captcha_answer: captcha.answer } : {};
  return { captcha, setCaptcha, reload, fields };
}

export function CaptchaField({ captcha, setCaptcha, reload, prefix }) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <Label data-testid={`${prefix}-captcha-question`}>{captcha?.question || "Chargement du CAPTCHA…"}</Label>
        <button type="button" onClick={reload} className="text-zinc-500 hover:text-amber-400 transition-colors" title="Nouvelle question" data-testid={`${prefix}-captcha-reload`}><RefreshCw size={14} /></button>
      </div>
      <Input inputMode="numeric" required autoComplete="off" placeholder="Votre réponse" value={captcha?.answer || ""}
        onChange={(e) => setCaptcha({ ...captcha, answer: e.target.value })} data-testid={`${prefix}-captcha-input`} />
    </div>
  );
}
